module.exports = __webpack_public_path__ + "static/media/computer.6d9ad96f.jpg";